// GlassConfiguration.js - Main entry point for Glass Configuration
// This component renders the tabbed interface for managing all glass-related data
import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { GlassGenericTab } from './GlassCommon';

const GlassConfiguration = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: 'Glazing Type', endpoint: 'glazing-types', entityName: 'Glazing Type' },
    { label: 'Textured Design', endpoint: 'textured-designs', entityName: 'Textured Design' },
    { label: 'Tinted Design', endpoint: 'tinted-designs', entityName: 'Tinted Design' },
    { label: 'Glass Energy', endpoint: 'energy', entityName: 'Glass Energy' },
    { label: 'Glass Strength', endpoint: 'strength', entityName: 'Glass Strength' },
    { label: 'Glass Thickness', endpoint: 'thickness', entityName: 'Glass Thickness' },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ mb: 2 }}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      <GlassGenericTab
        endpoint={tabs[activeTab].endpoint}
        entityName={tabs[activeTab].entityName}
        key={tabs[activeTab].endpoint}
      />
    </Box>
  );
};

export default GlassConfiguration;
